export const BannerBadge = ({ url }) => {
    return (
        <svg
            width="68"
            height="75"
            viewBox="0 0 68 75"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            href="http://www.w3.org/1999/xlink"
        >
            <rect y="0.660156" width="68" height="71" fill="url(#pattern0_12376_40335)" />
            <defs>
                <pattern id="pattern0_12376_40335" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use href="#image0_12376_40335" transform="matrix(0.00261029 0 0 0.0025 -0.00117647 0)" />
                </pattern>
                <image id="image0_12376_40335" width="384" height="400" preserveAspectRatio="none" href={url} />
            </defs>
        </svg>
    );
};
